import { NgModule } from '@angular/core';
import { DatePipe } from '../pipes/date.pipe';
import { ReplacePipe } from '../pipes/replace.pipe';
import { ZeroPaddingPipe } from '../pipes/zero-padding.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { DateEcwidPipe } from './dateecwid.pipe';

@NgModule({
    imports: [
    ],
    declarations: [
        ReplacePipe,
        DatePipe,
        DateEcwidPipe,
        ZeroPaddingPipe,
        SafeHtmlPipe
    ],
    exports: [
        ReplacePipe,
        DatePipe,
        DateEcwidPipe,
        ZeroPaddingPipe,
        SafeHtmlPipe
    ]
})

export class PipesModule { }
